module.exports = __webpack_public_path__ + "static/making-silicon-valley-e2e9f58d6728f5f0548afedafd94c0d5.jpg";